<template>
  <div>
    <div class="pb-3 pt-3">
      <h5>
        <strong @click="$emit('toIndex')" style="cursor: pointer">
          <arrow-left-icon class="pb-1"/>
          Voltar para a listagem de motoristas
        </strong>
      </h5>
    </div>

    <div class="ibox">
      <div class="ibox-title pt-3">
        <h5><strong>Motorista</strong></h5>
      </div>
        
      <div class="ibox-content">
        <div class="row">
          <div class="col-md-6">
            <div>
              <p><strong>CPF: </strong>{{ driver.cpf | cpf }}</p>
            </div>
            <div>
              <p><strong>Nome: </strong>{{ driver.name }}</p>
            </div>
            <div>
              <p><strong>Telefone: </strong>{{ driver.phone | phone }}</p>
            </div>
            <div>
              <p><strong>Categoria: </strong>{{ driver.category }}</p>
            </div>
          </div>

          <div class="col-md-6">
            <div>
              <p><strong>Criado por: </strong>{{ driver.createdBy || '-' }}</p>
            </div>
            <div>
              <p><strong>Criado em: </strong>{{ driver.createdAt | datetime }}</p>
            </div>
            <div>
              <p><strong>Atualizado por: </strong>{{ driver.updatedBy || '-' }}</p>
            </div>
            <div>
              <p><strong>Atualizado em: </strong>{{ driver.updatedAt | datetime }}</p>
            </div>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-md-12">
            <h6><strong>Anexos</strong></h6>
          </div>
        </div>

        <div class="row mt-2">
          <div class="col-md-6">
            <p><strong>CNH</strong></p>
            <span :class="driver.cnhFileAttached ? 'badge-success' : 'badge-secondary'" class="badge mr-2">
              {{ driver.cnhFileAttached ? 'Anexado' : 'Pendente' }}
            </span>
            <button
              v-if="driver.cnhFileAttached"
              class="btn btn-outline btn-sm"
              :disabled="downloading"
              @click="downloadCnhFile"
            >
              <download-icon size="1x" class="mr-1"/>
              {{ downloading ? 'Baixando...' : 'Baixar CNH' }}
            </button>
          </div>
        </div>

        <div class="row mt-2">
          <div class="col-md-12">
            <button
              v-if="$withPolicy('application', 'drivers/insert_or_update')"
              class="btn btn-outline btn-md mr-2"
              @click="$emit('editDriver', driver)"
            >
              Editar
            </button>

            <button
              v-if="$withPolicy('application', 'drivers/delete')"
              class="btn btn-outline-red float-right"
              @click="$emit('sendDeleteDriver', driver)"
            >
              Excluir motorista
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import GetAccountApps from '@/mixins/GetAccountApps'

  import { ArrowLeftIcon, DownloadIcon } from 'vue-feather-icons'

  export default {
    components: { ArrowLeftIcon, DownloadIcon },
    computed: {
      accountApps() {
        return this.getAccountApps.filter(aa => ['cm-frotas', 'cm-crono', 'cm-taxas'].includes(aa.name))
      },
    },
    data: () => ({
      downloading: false,
    }),
    methods: {
      downloadCnhFile() {
        this.downloading = true
        this.axios.get(`drivers/${this.driver.id}/cnh_file`, { responseType: 'blob' })
          .then(blob => this.$parse.buildDownload(`cnh_${this.driver.cpf}.${this.fileExtension(blob)}`, blob))
          .catch(error => this.$notify.addError(error))
          .finally(() => { this.downloading = false })
      },
      fileExtension(blob) {
        const type = (blob && blob.type) || ''
        return type.split('/')[1] || 'pdf'
      }
    },
    mixins: [GetAccountApps],
    name: 'Show',
    props: {
      driver: { required: true, type: Object }
    }
  }
</script>

<style scoped lang="scss">
 .card{
    height: 100%;
  }

  p{
    color: var(--primary-text-color);
  }

  .table td{
    vertical-align: middle;
  }

</style>
